import { FC, useContext, useState } from "react"
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import './changenamemodal.css'
import { InputText } from "primereact/inputtext";
import { FcCancel } from 'react-icons/fc'
import { TfiSave } from 'react-icons/tfi'
import { HiOutlineIdentification } from "react-icons/hi2";
import { changeScenarioName } from "../../../services/scenario-service";
import { error, success } from "../../../utils/notifications";
import { catchResponse } from "../../../utils/helperFunctions";
import { UserContext } from "../../../Redux/UserContext";
import { FiCommand } from "react-icons/fi";

export const ChangeNameModal:FC<any> = (props):JSX.Element => {

    const { visible, setVisible, actualName , newScenarioName, setNewScenarioName, scenarioId, flagChangeScenario, setFlagChangeScenario,scenarioPlant } = props

    const [state] = useContext(UserContext)

    const [loadingChangeName, setLoadingChangeName] = useState<boolean>(false)

    const handleChangeName = async() => {
        try {
            setLoadingChangeName(true)
            let body:any = {
                id_scenario: scenarioId,
                new_name: newScenarioName
            }
            const res = await changeScenarioName(body)
            if(res.status === 200) {
                const { message, code } = res.data
                if(code === 200) {
                    success(message)
                    setNewScenarioName("")
                    setVisible(false)
                    setLoadingChangeName(false)
                    setFlagChangeScenario(!flagChangeScenario)
                } else {
                    setLoadingChangeName(false)
                    error(message)
                }
                setLoadingChangeName(false)
            }
        } catch(err:any) {
            setLoadingChangeName(false)
            catchResponse(err)
        }
    }


    const headerContent = (
        <div className="changename-header">
            <span>Cambiar nombre de escenario</span>
        </div>
    )

    const footerContent = (
        <div className="changename-footer">
            <Button severity={'danger'} label="Cancelar" icon={<FcCancel style={{fontSize:20}} />} onClick={() => setVisible(false)}  outlined />
            <Button severity={'success'} label="Guardar" icon={loadingChangeName? <FiCommand className="loading-icon" style={{fontSize:20}} /> :<TfiSave style={{fontSize:20}} />} disabled={state?.rol_id !== undefined? [3,4].includes(state?.rol_id) || loadingChangeName || !state?.id_plants.includes(scenarioPlant) : false} onClick={handleChangeName}  outlined />
        </div>
    );


    return (
        <div className="card flex justify-content-center">
            <Dialog header={headerContent} visible={visible} style={{ width: '50vw' }} onHide={() => setVisible(false)} footer={footerContent}>
                <div className="changename-modal-container">

                    <div className="card flex justify-content-center">
                        <label style={{fontFamily: 'var(--roboto-heavy)'}} htmlFor="pajera">Nombre actual</label>
                        <div className="p-inputgroup flex-1">
                            <span className="p-inputgroup-addon">
                                <HiOutlineIdentification style={{fontSize:20}} />
                            </span>
                            <InputText value={actualName} disabled />
                        </div>    
                    </div>

                    <div className="card flex justify-content-center">
                        <label style={{fontFamily: 'var(--roboto-heavy)'}} htmlFor="transporte">Nuevo nombre</label>
                        <div className="p-inputgroup flex-1">
                            <span className="p-inputgroup-addon">
                                <HiOutlineIdentification style={{fontSize:20}} />
                            </span>
                            <InputText value={newScenarioName} onChange={(e:any) => setNewScenarioName(e.target.value)}  />
                        </div>     
                    </div>

                </div>
            </Dialog>
        </div>
    )
}